const FighterMediaIndex = () => import('./views/FighterMediaIndex.vue')
const FighterMediaCreate = () => import('./views/FighterMediaCreate.vue')
const FighterMediaEdit = () => import('./views/FighterMediaEdit.vue')

export default [
  {
    path: 'media',
    name: 'fighters.media.index',
    component: FighterMediaIndex
  },
  {
    path: 'media/create',
    name: 'fighters.media.create',
    component: FighterMediaCreate
  },
  {
    path: 'media/:mediaId(\\d+)',
    name: 'fighters.media.edit',
    component: FighterMediaEdit
  }
]
